import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';
import { useSupportStore } from '../state/use-support-store';
import { formatChatDate, organizationLabel } from '../utils';
import { useRedirectToAccount } from '../../user/useRedirectToAccount';

const ResidentCardContent = () => {
  const { thread } = useSupportStore();
  const user = thread?.user;
  const { handleSwitchToUserAccount } = useRedirectToAccount();

  if (!user) return null;

  const rows = [
    { label: 'Телефон', value: user.phone },
    { label: 'Email', value: user.email },
    { label: 'Компания', value: organizationLabel(thread.organization) },
    { label: 'Регистрация', value: formatChatDate(user.created_at) },
    { label: 'Объекты', value: user?.object_count == null ? '' : String(user.object_count) },
  ];

  return (
    <div className="flex h-full flex-col gap-4 overflow-y-auto p-4">
      <div>
        <p className="text-xs uppercase text-gray-400">Пользователь</p>
        <p className="mt-1 text-base font-medium text-gray-900">{user.fio || 'Без имени'}</p>
      </div>

      <dl className="flex flex-col gap-3">
        {rows.map((row) =>
          row.value ? (
            <div key={row.label}>
              <dt className="text-xs text-gray-400">{row.label}</dt>
              <dd className="break-all text-sm text-gray-800">{row.value}</dd>
            </div>
          ) : null
        )}
      </dl>

      <button onClick={() => handleSwitchToUserAccount(user?.id)} className="text-sm font-medium text-orange-600 hover:text-orange-500">
        Перейти в ЛК пользователя
      </button>
    </div>
  );
};

const ResidentCard = ({ open, onClose }) => {
  if (onClose) {
    if (!open) return null;

    return (
      <div className="absolute inset-0 z-10 flex justify-end bg-black/30" onClick={onClose}>
        <div className="h-full w-[300px] max-w-full bg-white shadow-xl" onClick={(event) => event.stopPropagation()}>
          <div className="flex justify-end p-2">
            <button type="button" aria-label="Закрыть" onClick={onClose} className="rounded-full p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
              <CloseIcon fontSize="small" />
            </button>
          </div>
          <ResidentCardContent />
        </div>
      </div>
    );
  }

  return <ResidentCardContent />;
};

export default ResidentCard;
